import Count from './index.vue'

Count.install = function (Vue) {
  Vue.component(Count.name, Count)
}

export default Count
